import ProfilePatientsEhr from './profile-patients-ehr.vue'
export default ProfilePatientsEhr